/* eslint-disable no-new */
import { KeenSliderNavigation } from "./keen-slider-navigation-plugin";
import { KeenSliderKeyboardNavigation } from "./keen-slider-keyboard-navigation-plugin";
import KeenSlider from "keen-slider";
// todo: legacy code - rewrite to use global slider

export const buildFlavorsSlider = () => {
  const newOptions = {
    mode: "free-snap",
    loop: true,
    slides: {
      origin: "center",
      perView: "auto",
      spacing: 12,
    },
    breakpoints: {
      "(min-width: 768px)": {
        mode: "free-snap",
        loop: true,
        slides: {
          origin: "center",
          perView: "auto",
          spacing: 20,
        },
      },
    },
  };

  const defaultOptions = {
    mode: "free-snap",
    loop: true,
    slides: {
      origin: "center",
      perView: "auto",
      spacing: 50,
    },
  };

  document
    .querySelectorAll("[js-flavours-slider]")
    .forEach(function (sliderEl) {
      const newSlider = sliderEl.getAttribute("data-collection");

      new KeenSlider(sliderEl, newSlider ? newOptions : defaultOptions, [
        KeenSliderNavigation({ arrows: true, dots: false }),
        KeenSliderKeyboardNavigation,
      ]);

      const focusable = sliderEl.querySelectorAll("a, button, input, [tabindex]:not([tabindex='-1'])");

      focusable.forEach(function(el) {
        el.setAttribute("tabindex", "-1");
      });
    });
};
